import { IAbcComponent } from '../abcComponent.model';

export enum ButtonVariant {
  Basic = 'mat-button',
  Raised = 'mat-raised-button',
  Stroked = 'mat-stroked-button',
  Flat = 'mat-flat-button',
  Icon = 'mat-mdc-icon-button',
  Fab = 'mat-fab',
  MiniFab = 'mat-mini-fab',
  Text = 'text',
}

export enum Icon {
  Home = 'home',
  Menu = 'menu',
  Favorite = 'favorite',
  Open_in_new = 'open_in_new',
  Delete = 'delete',
  Bookmark = 'bookmark',
  More = 'more',
  Spinleft = 'spinleft',
  SpinNext = 'spinnext',
  Plus_one = 'plus_one',
  Filter_list = 'filter_list',
  None = '',
}

export enum ButtonColor {
  Primary = 'primary',
  Accent = 'accent',
  Warn = 'warn',
  Basic = 'basic',
  Disabled = 'disabled',
}

export enum ButtonIcon {
  icon = 'primary',
  FAB = 'FAB',
  MiniFAB = 'Mini FAB',
}

export interface IButton extends IAbcComponent {
  badgePosition?: badgePosition;
  badgeColor?: string;
  id: string;
  color: ButtonColor;
  variant: string;
  buttonBackgroundColor?: string;
  stylingMode?: ButtonVariant;
  value?: string;
  image?: string;
  icon?: Icon | string;
  iconColor?: string;
  iconBackgroundColor?: string;
  callBackFN?: any;
  visible?: boolean;
  hint?: string;
  focusStateEnabled?: boolean;
  hoverStateEnabled?: boolean;
  rtlEnabled?: boolean;
  text?: string;
  type?: TypeStyle;
  disabled?: boolean;
  badge?: number;
  setButtonStyle(style?: ButtonStyle);
  setCustomDataAttributes(data?: Object);
}

export class ButtonStyle {
  height: string | number = '100%';
  width: string | number = '100%';
}

export enum TypeStyle {
  Back = 'back',
  Danger = 'danger',
  Default = 'default',
  Normal = 'normal',
  Success = 'success',
}
export enum badgePosition {
  before = 'before',
  after = 'after',
  above = 'above',
  below = 'below',
  aboveAfter = 'above after', //the default value for matBadgePosition
}
